<template>
    <div class="form">
        <div class="form-section">
            <div class="form-section-heading">
                {{ trans('courses.headline.course_information') }}
            </div>

            <div class="form-row">
                <div class="form-row__col form-row__col--one-half">
                    <form-input
                        name="title"
                        :required="true"
                        v-model="fields.title"
                    >
                        {{ trans('courses.label.title') }}
                    </form-input>
                </div>

                <div class="form-row__col form-row__col--one-half" v-if="canSetDefaultVariations(this.course.variations)">
                    <form-selectbox
                        v-model="fields.defaultVariationId"
                        name="default_variation_id"
                        :options="this.defaultVariationOptions"
                    >
                        {{ trans('courses.label.default_variation') }}
                    </form-selectbox>
                </div>
            </div>

            <div class="form-row">
                <div class="form-row__col form-row__col--one-half">
                    <form-input
                        name="comment"
                        v-model="fields.comment"
                    >
                        {{ trans('courses.label.comment') }}
                    </form-input>
                </div>
            </div>

            <div class="form-row">
                <div class="form-row__col">
                    <form-text-area
                        v-model="fields.description"
                        name="description"
                        :rows="10">
                        {{ trans('courses.label.description') }}
                    </form-text-area>
                </div>
            </div>

            <div class="form-row">
                <div class="form-row__col">
                    <label class="label" for="image_path">{{ trans('courses.label.image_path') }}</label>
                    <dropzone :uploaded-file="fields.imagePath" name="image_path" @change="onChange" @remove="onRemove">
                        {{ trans('courses.note.image_upload') }}
                    </dropzone>
                </div>
            </div>
        </div>

        <div class="form-section">
            <div class="form-section-heading">
                {{ trans('courses.headline.additional_information') }}
            </div>

            <div class="form-row">
                <div class="form-row__col form-row__col--one-half">
                    <form-input
                        name="instruction_period"
                        type="number"
                        min="1"
                        step="1"
                        v-model="fields.instructionPeriod"
                        :placeholder="365"
                    >
                        {{ trans('courses.label.instruction_period') }}
                    </form-input>
                </div>
            </div>
        </div>

        <div class="form-section">
            <div class="form-section-heading">
                {{ trans('courses.headline.certificate_information') }}
            </div>

            <div class="form-row">
                <div class="form-row__col form-row__col--one-half">
                    <form-selectbox
                        v-model="fields.isCertifiable"
                        name="is_certifiable"
                        :options="[
                            {value: 1, label:trans('courses.label.is_certifiable_yes')},
                            {value: 0, label:trans('courses.label.is_certifiable_no')},
                        ]"
                    >
                        {{ trans('courses.label.is_certifiable') }}
                    </form-selectbox>
                </div>
            </div>

            <div class="form-row" v-if="fields.isCertifiable == '1'">
                <div class="form-row__col">
                    <form-text-area
                        v-model="fields.additionalInformation"
                        name="additional_information"
                        :rows="10">
                        {{ trans('courses.label.additional_information') }}
                    </form-text-area>
                </div>
            </div>

            <input v-model="deletedImage" id="deletedImage" name="deletedImage" type="hidden">
        </div>

        <div class="page-control">
            <div class="page-control__element">
                <button type="submit" class="btn btn--big btn--primary">{{ trans('buttons.submit') }}</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        'course' : {
            type: Object,
            default: () => { return {} }
        },
    },

    data() {
        return {
            fields: {
                title: this.old('title', this.course.title),
                comment: this.old('comment', this.course.comment),
                description: this.old('description', this.course.description),
                defaultVariationId: this.old('default_variation_id', this.getDefaultVariationId(this.course.variations)),
                imagePath: this.getImagePath(),
                instructionPeriod: this.old('instruction_period', this.course.instruction_period || 365),
                isCertifiable: this.old('is_certifiable', this.course.is_certifiable || 1),
                additionalInformation: this.old('additional_information', this.course.additional_information),
            },

            deletedImage: null
        };
    },

    computed: {
        // compute the data to show in the checkbox options
        defaultVariationOptions() {
            if (this.canSetDefaultVariations(this.course.variations)) {
                return this.course.variations.map((v) => ({
                    'value': v.id,
                    'label' : v.variation_name,
                }))
            }
        },
    },

    methods: {
        canSetDefaultVariations(variationsArray) {
            return Array.isArray(variationsArray) && variationsArray.length
        },

        onChange() {
            this.deletedImage = null;
        },

        onRemove() {
            this.fields.imagePath = ''
            this.deletedImage = this.course.image_path;
        },

        getImagePath() {
            var path = this.old('image_path', this.course.image_path || '')

            if (path !== '') {
                return '/storage/' + path;
            }

            return ''
        },

        getDefaultVariationId(variationsArray) {
            if (this.canSetDefaultVariations(variationsArray)) {
                var array = variationsArray.map((v) => ({
                    'value': v.id,
                    'is_default': v.is_default
                }))

                return array.filter(v => v.is_default == 1)[0].value
            }
        }
    }
}
</script>
